module.exports = __webpack_public_path__ + "static/email-template-payment-failed-4d31565fbda8acfc9da1e5d789898518.png";